export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Crypto-fa1cbbb625f590b77d52e11b111102a1.svg";